import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-verfiy-reportedlesson",
  templateUrl: "./verfiy-reportedlesson.component.html",
  styleUrls: ["./verfiy-reportedlesson.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
})
export class VerfiyReportedlessonComponent implements OnInit {
  public managerComments: string;

  constructor(public dialogRef: MatDialogRef<VerfiyReportedlessonComponent>) {}

  ngOnInit(): void {
    // This is intentional
  }

  confirm() {
    this.dialogRef.close({ managerComments: this.managerComments });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
